import { SignUpInput, CustomerType } from '@jetshop/core/types';

export type SignUpFormInput = SignUpInput & { country: string };

// ConsentBox stores { xL0: boolean }; API wants [{ id, value: boolean }]
function formatConsents(consents: unknown) {
  if (!consents) return null;

  if (Array.isArray(consents)) {
    return consents
      .filter((c) => c && c.id != null && typeof c.value === 'boolean')
      .map((c) => ({ id: String(c.id), value: c.value }));
  }

  if (typeof consents === 'object') {
    return Object.entries(consents as Record<string, unknown>)
      .filter(([, value]) => typeof value === 'boolean')
      .map(([id, value]) => ({ id, value: value as boolean }));
  }

  return null;
}

// Map forms to { valuename: { value: "value" } } format required for input
// e.g. { country: { value: "Sweden" } }
export function formatSignupInput(values: SignUpFormInput): SignUpInput {
  const {
    emailAddress,
    password,
    pid,
    country,
    externalId,
    consents,
    ...rest
  } = values;

  // Currently passing through country.code:country.name for the country
  // selector. This is a hack for now to get the code and name separately.
  const [countryCode, countryName] = country.split(':');

  const billingInput: {
    [key: string]: any;
  } = {
    countryCode: { value: countryCode },
  };
  const rawValues = Object.entries(rest);

  const formated_consents = formatConsents(consents);

  for (const [field, value] of rawValues) {
    billingInput[field] = {
      value: field === 'country' ? countryName : value,
    };
  }

  return {
    type: 'PRIVATE' as CustomerType.Private,
    billingAddress: billingInput,
    emailAddress,
    password,
    pid,
    externalId,
    consents: formated_consents,
  };
}
